<div class="custom-dialog">
    <div class="container d-justify-bw">
        <div class="custom-dialog__left" [formGroup]="BulkUploadForm">
            <div class="mat-dialog-title custom-dialog__title d-justify-bw">
                <h2 class="mat-dialog-title"> {{content?.['b2b.managetraveler.uploadbulktravelers']}} </h2>
                <div class="close">
                    <button mat-icon-button aria-label="Close dialog" (click)="CloseDialog()">
                    <mat-icon fontSet="material-symbols-outlined" aria-hidden="true">close</mat-icon>
                    </button>
                </div>
            </div>
            <mat-dialog-content class="custom-dialog__text">
                <div class="custom-dialog__description">
                    <div class="upload-popbox">
                        <div class="f-col">
                            <span><img src="assets/images/upload-illustration.svg" alt="upload" /></span>
                            <button mat-button class="button--alt-small" (click)="fileInput.click()" >{{content?.['b2b.managetraveler.ubtchooseafile']}}</button>
                            <!-- Hidden file input     accept=".csv"       --> 
                            <input #fileInput type="file"  accept=".csv" class="d-none" (change)="onFileSelected($event)" />
                    
                            <!-- Error or message -->
                            <p class="text-upload error" *ngIf="uploadError">{{content?.['b2b.managetraveler.ubtfileuploaderror']}}</p>
                            <p class="text-upload error" *ngIf="fileTooLarge">{{content?.['b2b.managetraveler.ubtfileexceedslimit']}}</p>
                            <p class="text-upload error" *ngIf="recordsLimitExceeded">The file exceeds the maximum allowed number of records.</p>
                            <p class="text-upload" *ngIf="fileSelected && uploadedFileName">{{uploadedFileName}}</p>
                        </div>
                    </div>
                    

                    <div class="uploaddocs-list" (click)="onDocsListClick($event)" [innerHTML]="sanitizedDesc">
                    </div>
                </div>
            </mat-dialog-content>

            <mat-dialog-actions class="upload-action">
                <div class="checkbox">
                    <mat-checkbox class="checkbox-wrapper"  (change)="onCheckboxChanged($event)">
                        {{content?.['b2b.managetraveler.ubtcheckboxcontent']}}
                      </mat-checkbox>

                </div>                
                <div class="dialog-actions-right">
                    <button
                    class="button--primary-small"
                    mat-button
                    (click)="UploadTraveller()"
                    [disabled]="!isFormValid()"
                    [ngClass]="{ disabled: !IsFormValidd }"
                >
                {{content?.['b2b.managetraveler.ubtupload']}}
                </button>
                </div>
            </mat-dialog-actions>
        </div>
    </div>
</div>

<ng-template #processingTemplate>
  <div class="custom-popup-gen-container processing-popup">
    <div class="custom-popup-gen-body processing-popup-body">
      <mat-spinner diameter="40"></mat-spinner>
      <p>Please wait, this might take some time...</p>
    </div>
  </div>
</ng-template>